
export default {
  reportInfo: {},
  activeToken: {},
  activeType: 'riskLabels',
  activeFunds: 'full',
  activeSort: null,
  activeRowName: null,
  purchasedInfo: {},
  isLegacy: null,
  reloadInfo: {},
  currentPrices: {},
  sofExposureHeader: {},
  uofExposureHeader: {},
  sofExposure: {},
  uofExposure: {},
  sofTransactions: {},
  uofTransactions: {},
  sofCurrencies: {},
  uofCurrencies: {},
  reportHeaderData: {},
  reportHeaderEmit: '',
  isGenerateReportLoaderVisible: false,
  exampleId: null,
}
